var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6141 2.89137C12.4969 2.77416 12.338 2.70831 12.1722 2.70831C12.0064 2.70831 11.8475 2.77416 11.7303 2.89137L4.06994 10.5517C3.99142 10.6302 3.93524 10.7282 3.90717 10.8357L3.07384 14.026C3.01776 14.2407 3.07971 14.469 3.23661 14.6259C3.3935 14.7828 3.62182 14.8448 3.8365 14.7887L7.02686 13.9554C7.1343 13.9273 7.23232 13.8711 7.31085 13.7926L14.9712 6.13228C15.2152 5.8882 15.2152 5.49247 14.9712 5.24839L12.6141 2.89137ZM5.07374 11.3157L12.1722 4.2172L13.6453 5.69034L6.54688 12.7888L4.5529 13.3096L5.07374 11.3157Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 16.0416C2.9882 16.0416 2.70837 16.3215 2.70837 16.6666C2.70837 17.0118 2.9882 17.2916 3.33337 17.2916H15.8334C16.1786 17.2916 16.4584 17.0118 16.4584 16.6666C16.4584 16.3215 16.1786 16.0416 15.8334 16.0416H3.33337Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAlt);
export default __webpack_public_path__ + "static/media/Edit-alt.3510afc4b1804eebe19cb5e0228a64d1.svg";
export { ForwardRef as ReactComponent };